/*
 * Copyright (c) Worldline 2023.
 */

import {Injectable} from '@angular/core';

import {HttpClient, HttpHeaders} from "@angular/common/http";

import {Observable} from 'rxjs';
import {Response} from "../model/response";
import {HandSignDto} from "../model/handSignDto";
import {OtpSendDto} from "../model/otpSendDto";
import {CancellationReasonDto} from "../model/cancellationReasonDto";
import {RootScopeService} from "../services/rootscope.service";
import {TempDataAffectationDto} from "../model/tempDataAffectationDto";

@Injectable({
    providedIn: 'root'
})
export class HttpService {

    constructor(public httpClient: HttpClient, private rootScope: RootScopeService) {

        // this.url = this.rootScope.get().properties?.api.url


    }

    private url() {
        return this.rootScope.get().properties.api.url
    }

    // Http Headers

    public getHttpOptions(): object {
        return {
            headers: new HttpHeaders({
                'Accept': 'application/json, text/plain, */*',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')?.replace("short-id:", ""),
                'skip-sign-on-agree': 'true'
            })
        }
    }

    getAllSigners(sessionId: string): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers')
        return this.httpClient.get<Response>(this.url() + '/sessions/' + sessionId + '/signers', this.getHttpOptions());
    }

    getSession(sessionId: string): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId)
        return this.httpClient.get<Response>(this.url() + '/sessions/' + sessionId, this.getHttpOptions())
    }

    getAllEvidences(sessionId: string, signerId: string): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences')
        return this.httpClient.get<Response>(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences', this.getHttpOptions())
    }

    getAllConsents(sessionId: string, signerId: string, documentId: string): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/' + documentId + "/consents")
        return this.httpClient.get<Response>(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/' + documentId + "/consents", this.getHttpOptions())
    }

    initAgreements(sessionId: string, signerId: string): Observable<Response> {

        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/initAgreements')
        return this.httpClient.put<Response>(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/initAgreements', null, this.getHttpOptions())

    }

    getAllSignatures(sessionId: string, signerId: string): Observable<Response> {

        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/signatures')
        return this.httpClient.get<Response>(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/signatures', this.getHttpOptions())

    }

    hold(sessionId: string, signerId: string): Observable<Response> {

        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/hold')
        return this.httpClient.post<Response>(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/hold', null, this.getHttpOptions())
    }

    sendToSmartphone(sessionId: string, signerId: string, documentId: string, otpSendDto: OtpSendDto): Observable<Response> {

        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/' + documentId + '/smartphone')
        return this.httpClient.post<Response>(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/' + documentId + '/smartphone', otpSendDto, this.getHttpOptions())
    }

    updateAllConsents(sessionId: string, signerId: any, documentId: string, body: any): Observable<Response> {

        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/' + documentId + '/consents')
        return this.httpClient.put<Response>(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/' + documentId + '/consents', body, this.getHttpOptions())
    }

    clickAgreement(sessionId: string, signerId: string, documentId: string): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/' + documentId + '/agreements/click')
        return this.httpClient.put<Response>(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/' + documentId + '/agreements/click', null, this.getHttpOptions())
    }

    sendConsentCgs(sessionId: string, signerId: string, data: any): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/consents/gcs')
        return this.httpClient.post<Response>(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/consents/gcs', data, this.getHttpOptions())
    }

    sendOtp(sessionId: string, signerId: string, documentId: string, body: any): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/' + documentId + '/otps')
        return this.httpClient.post<Response>(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/' + documentId + '/otps', body, this.getHttpOptions())
    }

    submitOtp(sessionId: string, signerId: string, documentId: string, body: any): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/' + documentId + '/otps')
        return this.httpClient.put<Response>(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/' + documentId + '/otps', body, this.getHttpOptions())
    }

    ssoAgreement(sessionId: string, signerId: string, documentId: string): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/' + documentId + '/agreements/sso')
        return this.httpClient.put<Response>(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/' + documentId + '/agreements/sso', null, this.getHttpOptions())
    }

    handSignAgreement(sessionId: string, signerId: string, documentId: string, body: HandSignDto): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/' + documentId + '/agreements/handSign')
        return this.httpClient.put<Response>(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/' + documentId + '/agreements/handSign', body, this.getHttpOptions())
    }

    createJNLPSession(sessionId: string, signerId: string, documentId: string): Observable<Response> {
        console.debug("http url = ", this.url() + '/jnlp/sessions/' + sessionId + '/signers/' + signerId + '/signatures/' + documentId + '/jws')
        return this.httpClient.post<Response>(this.url() + '/jnlp/sessions/' + sessionId + '/signers/' + signerId + '/signatures/' + documentId + '/jws', null, this.getHttpOptions())
    }

    getJNLPSession(token: string): Observable<Response> {
        console.debug("http url = ", this.url() + '/jnlp/token/' + token)
        return this.httpClient.get<Response>(this.url() + '/jnlp/token/' + token, this.getHttpOptions())
    }

    loadShortIdSession(shortId: string): Observable<Response> {
        console.debug("http url = ", this.url() + '/shortId/' + shortId, this.getHttpOptions())

        return this.httpClient.get<Response>(this.url() + '/shortId/' + shortId, this.getHttpOptions())
    }

    signDocuments(sessionId: string, signerId: string): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/sign')
        return this.httpClient.put<Response>(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/documents/sign', null, this.getHttpOptions())
    }

    validate(sessionId: string, signerId: string, subscriberId: string): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/subscribers/' + subscriberId + '/certificateApproval')
        return this.httpClient.put<Response>(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/subscribers/' + subscriberId + '/certificateApproval', null, this.getHttpOptions())
    }

    cancel(sessionId: string, signerId: string, dto: CancellationReasonDto): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/cancel/')
        return this.httpClient.post(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/cancel/', dto, this.getHttpOptions())
    }

    getAllWithTemp(sessionId: string, signerId: string): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/temp');
        return this.httpClient.get(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/temp', this.getHttpOptions())
    }

    analyse(sessionId: string, signerId: string): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/all/analyse');
        return this.httpClient.put(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/all/analyse', null, this.getHttpOptions())
    }

    retryEvidences(sessionId: string, signerId: string): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/retry');
        return this.httpClient.put(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/retry', null, this.getHttpOptions())
    }

    getRawData(sessionId: string, signerId: string, extEvidenceId: string, extEvidencePartId: string): Observable<Blob> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/' + extEvidenceId + '/' + extEvidencePartId + '/data/view');
        return this.httpClient.get(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/' + extEvidenceId + '/' + extEvidencePartId + '/data/view', {
            headers: this.getHttpOptions()['headers'],
            responseType: 'blob'
        })
    }

    resetEvidenceType(sessionId: string, signerId: string, extEvidenceId: string): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/' + extEvidenceId + '/type');
        return this.httpClient.delete(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/' + extEvidenceId + '/type', this.getHttpOptions())
    }

    setEvidenceType(sessionId: string, signerId: string, extEvidenceId: string, type: object): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/' + extEvidenceId + '/type');
        return this.httpClient.post(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/' + extEvidenceId + '/type', type, this.getHttpOptions())
    }

    uploadEvidence(sessionId: string, signerId: string, evidenceId: string, evidencePartId: string, formData): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/' + evidenceId + '/' + evidencePartId + '/data');
        return this.httpClient.post(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/' + evidenceId + '/' + evidencePartId + '/data', formData, this.getHttpOptions())
    }

    skipTempDataPage(sessionId: string, signerId: string, evidenceId: string, page: number): Observable<Response> {
        console.debug("http url = ", this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/' + evidenceId + '/temp/' + page);
        return this.httpClient.delete(this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/' + evidenceId + '/temp/' + page, this.getHttpOptions())
    }

    getEvidenceTemp(sessionId: string, signerId: string, evidenceId: string, page: number): Observable<Blob> {
        const url = this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/' + evidenceId + '/temp/' + page + '#' + Math.random();
        console.debug("http url = ", url);
        return this.httpClient.get(url, {
            headers: this.getHttpOptions()['headers'],
            responseType: 'blob'
        })
    }

    getEvidencePart(sessionId: string, signerId: string, evidenceId: string, evidencePartId: string): Observable<Response> {
        const url = this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/' + evidenceId + '/' + evidencePartId;
        console.debug("http url = ", url);
        return this.httpClient.get(url, this.getHttpOptions())
    }

    checkUpload(sessionId: string, signerId: string, evidenceId: string): Observable<Response> {
        const url = this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/' + evidenceId + '/check';
        console.debug("http url = ", url);
        return this.httpClient.get(url, this.getHttpOptions())
    }

    removePart(sessionId: string, signerId: string, evidenceId: string, evidencePartId: string): Observable<Response> {
        const url = this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/' + evidenceId + '/' + evidencePartId + '/data';
        console.debug("http url = ", url);
        return this.httpClient.delete(url, this.getHttpOptions())
    }

    affectTempDataPageToPart(sessionId: string, signerId: string, evidenceId: string, evidencePartId: string, dto: TempDataAffectationDto): Observable<Response> {
        const url = this.url() + '/sessions/' + sessionId + '/signers/' + signerId + '/evidences/' + evidenceId + '/' + evidencePartId + '/affect';
        console.debug("http url = ", url);
        return this.httpClient.post(url, dto, this.getHttpOptions())
    }
}
